export const SET_FOCUSED_FOLDERS = "SET_FOCUSED_FOLDERS";
export const RESET_FOCUSED_FOLDERS = "RESET_FOCUSED_FOLDERS";
export const SET_SECRETARY_MODE = "SET_SECRETARY_MODE";

export const API_GET_FOCUSED_FOLDERS = "API_GET_FOCUSED_FOLDERS";
export const API_GET_FOCUSED_FOLDERS_SUCCESS = "API_GET_FOCUSED_FOLDERS_SUCCESS";
export const API_GET_FOCUSED_FOLDERS_FAIL = "API_GET_FOCUSED_FOLDERS_FAIL";

export const API_POST_PHOTO_FOLDER = "API_POST_PHOTO_FOLDER";
export const API_POST_PHOTO_FOLDER_SUCCESS = "API_POST_PHOTO_FOLDER_SUCCESS";
export const API_POST_PHOTO_FOLDER_FAIL = "API_POST_PHOTO_FOLDER_FAIL";

export const API_DELETE_PHOTO_FOLDER = "API_DELETE_PHOTO_FOLDER";
export const API_DELETE_PHOTO_FOLDER_SUCCESS = "API_DELETE_PHOTO_FOLDER_SUCCESS";
export const API_DELETE_PHOTO_FOLDER_FAIL = "API_DELETE_PHOTO_FOLDER_FAIL";

export const API_POST_FOLDER = "API_POST_FOLDER";
export const API_POST_FOLDER_SUCCESS = "API_POST_FOLDER_SUCCESS";
export const API_POST_FOLDER_FAIL = "API_POST_FOLDER_FAIL";

export const API_VALIDATE_FOLDERS = "API_VALIDATE_FOLDERS";
export const API_VALIDATE_FOLDERS_SUCCESS = "API_VALIDATE_FOLDERS_SUCCESS";
export const API_VALIDATE_FOLDERS_FAIL = "API_VALIDATE_FOLDERS_FAIL";

export const API_GET_FOLDER_BY_CODE = "API_GET_FOLDER_BY_CODE";

export const API_GET_PATIENT_EXISTING_FOLDER = "API_GET_PATIENT_EXISTING_FOLDER";
export const API_GET_PATIENT_EXISTING_FOLDER_SUCCESS = "API_GET_PATIENT_EXISTING_FOLDER_SUCCESS";
export const API_GET_PATIENT_EXISTING_FOLDER_FAIL = "API_GET_PATIENT_EXISTING_FOLDER_FAIL";

export const API_PATCH_OPEN_FOLDER = "API_PATCH_OPEN_FOLDER";
export const API_PATCH_OPEN_FOLDER_SUCCESS = "API_PATCH_OPEN_FOLDER_SUCCESS";
export const API_PATCH_OPEN_FOLDER_FAIL = "API_PATCH_OPEN_FOLDER_FAIL";

export const API_PATCH_FOLDER_PATIENT = "API_PATCH_FOLDER_PATIENT";
export const API_PATCH_FOLDER_PATIENT_SUCCESS = "API_PATCH_FOLDER_PATIENT_SUCCESS";
export const API_PATCH_FOLDER_PATIENT_FAIL = "API_PATCH_FOLDER_PATIENT_FAIL";

export const API_PATCH_CANCEL_FOLDER = "API_PATCH_CANCEL_FOLDER";
export const API_PATCH_CANCEL_FOLDER_SUCCESS = "API_PATCH_CANCEL_FOLDER_SUCCESS";
export const API_PATCH_CANCEL_FOLDER_FAIL = "API_PATCH_CANCEL_FOLDER_FAIL";

export const API_UPDATE_PHOTO_FOLDER = "API_UPDATE_PHOTO_FOLDER";
export const API_UPDATE_PHOTO_FOLDER_SUCCESS = "API_UPDATE_PHOTO_FOLDER_SUCCESS";
export const API_UPDATE_PHOTO_FOLDER_FAIL = "API_UPDATE_PHOTO_FOLDER_FAIL";

export const API_GET_PATIENT_CLOSED_FOLDER = "API_GET_PATIENT_CLOSED_FOLDER";
export const API_GET_PATIENT_CLOSED_FOLDER_SUCCESS = "API_GET_PATIENT_CLOSED_FOLDER_SUCCESS";
export const API_GET_PATIENT_CLOSED_FOLDER_FAIL = "API_GET_PATIENT_CLOSED_FOLDER_FAIL";

export const API_GET_ALL_FOLDER = "API_GET_ALL_FOLDER";
export const API_GET_ALL_FOLDER_SUCCESS = "API_GET_ALL_FOLDER_SUCCESS";
export const API_GET_ALL_FOLDER_FAIL = "API_GET_ALL_FOLDER_FAIL";

export const API_PATCH_OPENED_BY = "API_PATCH_OPENED_BY";
export const API_PATCH_OPENED_BY_FAIL = "API_PATCH_OPENED_BY_FAIL";

export const API_COUNT_FOLDERS_GESLAB = "API_COUNT_FOLDERS_GESLAB";
export const API_COUNT_FOLDERS_GESLAB_SUCCESS = "API_COUNT_FOLDERS_GESLAB_SUCCESS";
export const API_COUNT_FOLDERS_GESLAB_FAIL = "API_COUNT_FOLDERS_GESLAB_FAIL";

export const API_GET_SEARCH_FOLDERS = "API_GET_SEARCH_FOLDERS";
export const API_GET_SEARCH_FOLDERS_SUCCESS = "API_GET_SEARCH_FOLDERS_SUCCESS";
export const API_GET_SEARCH_FOLDERS_FAIL = "API_GET_SEARCH_FOLDERS_FAIL";

export const API_GET_FOLDERS_TO_VALIDATE = "API_GET_FOLDERS_TO_VALIDATE";
export const API_GET_FOLDERS_TO_VALIDATE_SUCCESS = "API_GET_FOLDERS_TO_VALIDATE_SUCCESS";
export const API_GET_FOLDERS_TO_VALIDATE_FAIL = "API_GET_FOLDERS_TO_VALIDATE_FAIL";

export const API_GET_NEXT_FOLDER_TO_VALIDATE = "API_GET_NEXT_FOLDER_TO_VALIDATE";

export const API_GET_FOLDERS_FUTURE = "API_GET_FOLDERS_FUTURE";
export const API_GET_FOLDERS_FUTURE_SUCCESS = "API_GET_FOLDERS_FUTURE_SUCCESS";
export const API_GET_FOLDERS_FUTURE_FAIL = "API_GET_FOLDERS_FUTURE_FAIL";

export const API_GET_FOLDERS_PAUSED = "API_GET_FOLDERS_PAUSED";
export const API_GET_FOLDERS_PAUSED_SUCCESS = "API_GET_FOLDERS_PAUSED_SUCCESS";
export const API_GET_FOLDERS_PAUSED_FAIL = "API_GET_FOLDERS_PAUSED_FAIL";

export const API_GET_FOLDERS_COUNT = "API_GET_FOLDERS_COUNT";
export const API_GET_FOLDERS_COUNT_SUCCESS = "API_GET_FOLDERS_COUNT_SUCCESS";
export const API_GET_FOLDERS_COUNT_FAIL = "API_GET_FOLDERS_COUNT_FAIL";

export const API_PATCH_PAUSE_FOLDER_VALIDATION = "API_PATCH_PAUSE_FOLDER_VALIDATION";
export const API_PATCH_PAUSE_FOLDER_VALIDATION_SUCCESS = "API_PATCH_PAUSE_FOLDER_VALIDATION_SUCCESS";
export const API_PATCH_PAUSE_FOLDER_VALIDATION_FAIL = "API_PATCH_PAUSE_FOLDER_VALIDATION_FAIL";

export const API_PATCH_COMMENTS = "API_PATCH_COMMENTS";
export const API_PATCH_COMMENTS_SUCCESS = "API_PATCH_COMMENTS_SUCCESS";
export const API_PATCH_COMMENTS_FAIL = "API_PATCH_COMMENTS_FAIL";

export const API_GET_NEXT_FOLDER_TO_SAMPLE = "API_GET_NEXT_FOLDER_TO_SAMPLE";

export const API_GET_NEXT_FOLDER_FUTURE = "API_GET_NEXT_FOLDER_FUTURE";

export const API_GET_NOT_GENERATED_FOLDERS = "API_GET_NOT_GENERATED_FOLDERS";
export const API_PATCH_NOT_GENERATED_FOLDERS = "API_PATCH_NOT_GENERATED_FOLDERS";

export const CLOSE_BARCODE_WARNING = "CLOSE_BARCODE_WARNING";

export const CLOSE_OPENEDBY_WARNING = "CLOSE_OPENEDBY_WARNING";

export const API_PATCH_FOLDER_GESLAB_ALERT = "API_PATCH_FOLDER_GESLAB_ALERT";
export const API_PATCH_FOLDER_GESLAB_ALERT_SUCCESS = "API_PATCH_FOLDER_GESLAB_ALERT_SUCCESS";
export const API_PATCH_FOLDER_GESLAB_ALERT_FAIL = "API_PATCH_FOLDER_GESLAB_ALERT_FAIL";

export const API_PATCH_FOLDER_FAMILY_LINK = "API_PATCH_FOLDER_FAMILY_LINK";
export const API_PATCH_FOLDER_FAMILY_LINK_SUCCESS = "API_PATCH_FOLDER_FAMILY_LINK_SUCCESS";
export const API_PATCH_FOLDER_FAMILY_LINK_FAIL = "API_PATCH_FOLDER_FAMILY_LINK_FAIL";

export const API_GET_SEARCH_FOLDERS_FAMILY_LINK = "API_GET_SEARCH_FOLDERS_FAMILY_LINK";
export const API_GET_SEARCH_FOLDERS_FAMILY_LINK_SUCCESS = "API_GET_SEARCH_FOLDERS_FAMILY_LINK_SUCCESS";
export const API_GET_SEARCH_FOLDERS_FAMILY_LINK_FAIL = "API_GET_SEARCH_FOLDERS_FAMILY_LINK_FAIL";

export const SET_PREVIOUS_FOLDER = "SET_PREVIOUS_FOLDER";

export const API_GET_SEARCH_FOLDERS_OPENED = "API_GET_SEARCH_FOLDERS_OPENED";
export const API_GET_SEARCH_FOLDERS_OPENED_SUCCESS = "API_GET_SEARCH_FOLDERS_OPENED_SUCCESS";
export const API_GET_SEARCH_FOLDERS_OPENED_FAIL = "API_GET_SEARCH_FOLDERS_OPENED_FAIL";

export const API_GET_SEARCH_TEMP_FOLDERS = "API_GET_SEARCH_TEMP_FOLDERS";
export const API_GET_SEARCH_TEMP_FOLDERS_SUCCESS = "API_GET_SEARCH_TEMP_FOLDERS_SUCCESS";
export const API_GET_SEARCH_TEMP_FOLDERS_FAIL = "API_GET_SEARCH_TEMP_FOLDERS_FAIL";

export const API_PATCH_CONFIRM_TEMP_FOLDER = "API_PATCH_CONFIRM_TEMP_FOLDER";
export const API_PATCH_CONFIRM_TEMP_FOLDER_SUCCESS = "API_PATCH_CONFIRM_TEMP_FOLDER_SUCCESS";
export const API_PATCH_CONFIRM_TEMP_FOLDER_FAIL = "API_PATCH_CONFIRM_TEMP_FOLDER_FAIL";

export const API_ADMIN_IMPORT_TEMP_FOLDERS = "API_ADMIN_IMPORT_TEMP_FOLDERS";
export const API_ADMIN_IMPORT_TEMP_FOLDERS_SUCCESS = "API_ADMIN_IMPORT_TEMP_FOLDERS_SUCCESS";
export const API_ADMIN_IMPORT_TEMP_FOLDERS_FAIL = "API_ADMIN_IMPORT_TEMP_FOLDERS_FAIL";
export const API_GET_WAITING_TUBES_FOLDERS = "API_GET_WAITING_TUBES_FOLDERS";
export const API_GET_WAITING_TUBES_FOLDERS_SUCCESS = "API_GET_WAITING_TUBES_FOLDERS_SUCCESS";
export const API_GET_WAITING_TUBES_FOLDERS_FAIL = "API_GET_WAITING_TUBES_FOLDERS_FAIL";

export const API_GET_MY_OPENED_FOLDERS = "API_GET_MY_OPENED_FOLDERS";
export const API_GET_MY_OPENED_FOLDERS_SUCCESS = "API_GET_MY_OPENED_FOLDERS_SUCCESS";
export const API_GET_MY_OPENED_FOLDERS_FAIL = "API_GET_MY_OPENED_FOLDERS_FAIL";

export const API_DELETE_MY_OPENED_FOLDERS = "API_DELETE_MY_OPENED_FOLDERS";
export const API_DELETE_MY_OPENED_FOLDERS_SUCCESS = "API_DELETE_MY_OPENED_FOLDERS_SUCCESS";

export const SET_TAB_RESULT = "SET_TAB_RESULT";
export const SET_TAB_PRESC = "SET_TAB_PRESC";
export const SET_TAB_ALIQUOT = "SET_TAB_ALIQUOT";
export const SET_TAB_TUBES = "SET_TAB_TUBES";

export const API_GET_WAITING_ALIQUOTS_FOLDERS = "API_GET_WAITING_ALIQUOTS_FOLDERS";
export const API_GET_WAITING_ALIQUOTS_FOLDERS_SUCCESS = "API_GET_WAITING_ALIQUOTS_FOLDERS_SUCCESS";
export const API_GET_WAITING_ALIQUOTS_FOLDERS_FAIL = "API_GET_WAITING_ALIQUOTS_FOLDERS_FAIL";

export const RESET_ALIQUOTS_WAITING = "RESET_ALIQUOTS_WAITING";

export const API_GET_FOLDER_HELP = "API_GET_FOLDER_HELP";
export const API_GET_FOLDER_HELP_SUCCESS = "API_GET_FOLDER_HELP_SUCCESS";

export const API_POST_IDENTITY_CHECK = "API_POST_IDENTITY_CHECK";

export const API_GET_FOLDER_BASED_ON_TUBE = "API_GET_FOLDER_BASED_ON_TUBE";

export const API_PUT_ENDO_ANSWERS = "API_PUT_ENDO_ANSWERS";
export const API_PUT_ENDO_ANSWERS_SUCCESS = "API_PUT_ENDO_ANSWERS_SUCCESS";
export const API_PUT_ENDO_ANSWERS_FAIL = "API_PUT_ENDO_ANSWERS_FAIL";

export const API_PUT_DEPOSIT = "API_PUT_DEPOSIT";
export const API_PUT_DEPOSIT_SUCCESS = "API_PUT_DEPOSIT_SUCCESS";
export const API_PUT_DEPOSIT_FAIL = "API_PUT_DEPOSIT_FAIL";

export const API_POST_MOTIVATIONS = "API_POST_MOTIVATIONS";
export const API_POST_MOTIVATIONS_SUCCESS = "API_POST_MOTIVATIONS_SUCCESS";
export const API_POST_MOTIVATIONS_FAIL = "API_POST_MOTIVATIONS_FAIL";

export const API_POST_EXPRESS = "API_POST_EXPRESS";
export const API_POST_EXPRESS_SUCCESS = "API_POST_EXPRESS_SUCCESS";
export const API_POST_EXPRESS_FAIL = "API_POST_EXPRESS_FAIL";

export const API_GET_EXPRESS_LIST = "API_GET_EXPRESS_LIST";
export const API_GET_EXPRESS_LIST_SUCCESS = "API_GET_EXPRESS_LIST_SUCCESS";
export const API_GET_EXPRESS_LIST_FAIL = "API_GET_EXPRESS_LIST_FAIL";

export const API_PUT_CENTER_APPOINTMENT_FOLDER = "API_PUT_CENTER_APPOINTMENT_FOLDER";
export const API_PUT_CENTER_APPOINTMENT_FOLDER_SUCCESS = "API_PUT_CENTER_APPOINTMENT_FOLDER_SUCCESS";
export const API_PUT_CENTER_APPOINTMENT_FOLDER_FAIL = "API_PUT_CENTER_APPOINTMENT_FOLDER_FAIL";
